// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__zlMRJ","inputWrap":"styles_inputWrap__3Dwu-","input":"styles_input__1emuX"};